// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "groupfolders-" + chunkId + ".js?v=" + {"vendors-node_modules_nextcloud_vue_dist_ncvuecomponents_js-node_modules_css-loader_dist_runti-78a4de":"06342a84ed4a4ab20138","sharing":"735e8a7c0de57d4debc9"}[chunkId] + "";
};